var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"project",class:{ 'is-guided-tutorial-on': _vm.isGuidedTutorialOn },staticStyle:{"overflow":"hidden","min-height":"600px"}},[_c('ProjectTopBar',{staticClass:"width-100",staticStyle:{"position":"fixed","width":"100%"},attrs:{"projectIdToReturn":_vm.projectIdToReturn}}),_c('router-view')],1),_c('InAppInjectables')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }